import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalConfirm, ModalAlert } from "../su/Modals.js";
//import PageObserve from "./PageObserve.js";


export default class PageDefault extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    // Pqp.trace("PageDefault - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
    PageCommon.disable($(".js-demo-submit"), true);

    $(".js-email").keyup(this.onCheckData.bind(this));
    $(".js-demo-submit").on("click", this.onDoSubmit.bind(this));
    $("body").keydown(this.onSendData.bind(this));

    if (document.querySelector(".home-general")) {
      document.querySelector("body").style.paddingTop = "0";
    }
  }


  onCheckData() {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    let Email = $.trim($(".js-email").val());
    if (Email != "" && Email.match(mailformat)) {
      PageCommon.disable($(".js-demo-submit"), false);
      return true;
    } else {
      PageCommon.disable($(".js-demo-submit"), true);
      return false;
    }
  }

  onSendData(e) {
    if (e.which == 13 && this.onCheckData()) {
      this.onDoSubmit();
    }
  }

  onDoSubmit(e) {
    this.showPreloader(true);
    let rq = {
      Type: 0,
      Email: $.trim($(".js-email").val()),
    }
    thatServiceManeger.standardCall("/api/app/sendemailfordemo", rq, this.onDoSubmitHandler.bind(this));
  }

  onDoSubmitHandler(rs) {
    // console.log(rs);
    this.showPreloader(false);

    let showError = false;
    let errorMessage = "Si è verificato un errore gravissimo"
    if (rs.StatusCode !== 200) {
      showError = true;
    } else {
      showError = !rs.Success;
    }
    if (showError) {
      let modal = new ModalAlert($("#template-modalAlert"));
      modal.create(
        {
          title: "ERROR",
          body: errorMessage,
          close: "CLOSE",
          error: true
        });
      modal.init();
      return;
    } else {
      let modal = new ModalAlert($("#template-modalAlert"));
      modal.create(
        {
          title: "",
          body: "Grazie, clicca sul pulsante download per scaricare il pdf della demo.",
          downloadBtn: "DOWNLOAD",
          hasDownload: (rs.UrlDownloadDocument !== null && rs.UrlDownloadDocument !== ""),
          downloadUrl: "/Pages/DownloadDemo.aspx",
          close: "CHIUDI"
        });
      modal.init();
      return;
    }
  }

  get isHomepage() {
    return true;
  }
}

